import { getTestIds } from 'seagull/utils/TestIds';
export const GetImportClientsModalTID = (parentTestId)=>getTestIds(parentTestId);
export const actionsFor = (mode, deps)=>{
    const { dismissModal, backToUpload, texts, testId } = deps;
    const { ImportClientsModalTestIds } = GetImportClientsModalTID(testId);
    if (mode.kind === 'result') {
        return {
            secondaryLabel: texts.actions.close(),
            secondaryTestId: ImportClientsModalTestIds.CloseButton(),
            onSecondary: dismissModal,
            primaryBi: 'import_clients_primary_noop',
            secondaryBi: 'import_clients_close'
        };
    }
    if (mode.kind === 'blockingError') {
        if (mode.errorKind === 'unreadableFile') {
            return {
                primaryLabel: texts.actions.uploadAnotherFile(),
                primaryTestId: ImportClientsModalTestIds.UploadAnotherFileButton(),
                onPrimary: backToUpload,
                primaryBi: 'import_clients_upload_another',
                secondaryLabel: texts.actions.close(),
                secondaryTestId: ImportClientsModalTestIds.CloseButton(),
                onSecondary: dismissModal,
                secondaryBi: 'import_clients_close'
            };
        }
        return {
            secondaryLabel: texts.actions.close(),
            secondaryTestId: ImportClientsModalTestIds.CloseButton(),
            onSecondary: dismissModal,
            primaryBi: 'import_clients_primary_noop',
            secondaryBi: 'import_clients_close'
        };
    }
    return {
        primaryBi: 'import_clients_primary_noop',
        secondaryBi: 'import_clients_secondary_noop'
    };
};
